import React from 'react'

const Calculators = () => {
	return <div>Calculators</div>
}

export default Calculators
